// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import './App.css';
// import Layout from './Components/Layout/Layout.js';
// import LoginRedirect from './Pages/Login/LoginRedirect.js';
// import useTokenVerification from './Pages/Login/TokenValidation.js';
// import BottomToust from './Components/BottomToust/BottomToust.jsx';
// import Login2 from './Pages/Login/LoginPage2.jsx';

// function App() {
//   const [showMessage, setShowMessage] = useState(false);
//   const [toastMessage, setToastMessage] = useState("");

//   const handleToastUpdate = (message) => {
//     setToastMessage(message);
//     setShowMessage(true);
//   };

//   useEffect(() => {
//     if (showMessage) {
//       const timer = setTimeout(() => {
//         setShowMessage(false);
//       }, 5000);

//       return () => clearTimeout(timer);
//     }
//   }, [showMessage]);

//   useTokenVerification(handleToastUpdate);

//   return (
//     <Router>
//       <BottomToust
//         showMessage={showMessage}
//         message={toastMessage}
//         handleCloseMessageModal={() => setShowMessage(false)}
//       />
//       <Routes>
//         <Route path="/" element={<Login2 />} />
//         <Route path="/*" element={<Layout />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;



import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import Layout from './Components/Layout/Layout.js';
import Login2 from './Pages/Login/LoginPage2.jsx';
import BottomToust from './Components/BottomToust/BottomToust.jsx';
import useTokenVerification from './Pages/Login/TokenValidation.js';
import img from "./Assets/check-images/main-bg-2.jpg"

const AppWrapper = () => {
  const location = useLocation();

  // ✅ Conditional background image based on route
  const backgroundImage =
    location.pathname === "/"
      ? './Assets/check-images/home-bg.jpg'
      : img;

  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const handleToastUpdate = (message) => {
    setToastMessage(message);
    setShowMessage(true);
  };

  useEffect(() => {
    if (showMessage) {
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showMessage]);

  useTokenVerification(handleToastUpdate);

  return (
    <div className="app-root">
      {/* Background image layer */}
      <div
        className="background-image"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      {/* Content with blur */}
      <div className="body_container">
        <BottomToust
          showMessage={showMessage}
          message={toastMessage}
          handleCloseMessageModal={() => setShowMessage(false)}
        />

        <Routes>
          <Route path="/" element={<Login2 />} />
          <Route path="/*" element={<Layout />} />
        </Routes>
      </div>
    </div>
  );
};

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
